import {getData} from "../api/get-data";

export const setItemAdd = ({title, buy, sell, link, date, groupId, shopId, resolveHandler, rejectHanlder}) => {
  // debugger;
  // resolveHandler(`Введите наименование товара`);
  // return;
  getData({
    'set_item_add': {
      'item_name': title,
      'price_buy': buy,
      'price_sell': sell,
      'remote_link': link,
      'delivery_date': date,
      'group_id': groupId,
      'shop_id': shopId,
    }
  })
  .then((response) => {
    if (response.result === `OK`) {
      resolveHandler();
    }

    if (response.result === `ERROR`) {
      rejectHanlder(response.error);
    }
  });
};
